import { OSF } from "../lib/osfmos";
import { CommandSurfaceType } from "./converter";
import * as MOS from "./mosManifest";
import { Utilities } from "./utilities";

export class ConversionContext {
  private _inputFormFactor: string;
  private _hostType: OSF.ManifestHostType;
  private _currentFunctionFileResid: string;
  private _currentVersionOverrideNumber: OSF.VersionOverridesNumber;
  private _currentVersionOverrideCapabilities: MOS.Capabilities[];
  private _currentRibbonIndex: number = ConversionContext.UnsetIndex;
  private _currentMenuIndex: number = ConversionContext.UnsetIndex;
  private _currentTabIndex: number = ConversionContext.UnsetIndex;
  private _currentGroupIndex: number = ConversionContext.UnsetIndex;
  private _currentCustomMobileGroupIndex: number = ConversionContext.UnsetIndex;
  private _currentControlIndex: number = ConversionContext.UnsetIndex;
  private _currentFixedControlIndex: number = ConversionContext.UnsetIndex;

  private _currentMenuItemIndex: number = ConversionContext.UnsetIndex;

  private _currentIconIndex: number = ConversionContext.UnsetIndex;

  // Context menu related localization file indexes
  private _currentContextMenuIndex: number = ConversionContext.UnsetIndex;
  private _currentContextMenuMenuIndex: number = ConversionContext.UnsetIndex;
  private _currentContextMenuMenuControlIndex: number = ConversionContext.UnsetIndex;
  private _currentContextMenuMenuControlMenuItemIndex: number = ConversionContext.UnsetIndex;

  private _currentCommandSurfaceType: CommandSurfaceType = CommandSurfaceType.None;

  private _isInFixedControl: boolean = false;

  public static UnsetIndex: number = -1;

  constructor() {
    this._hostType = null;
    this._inputFormFactor = null;
  }

  getFormFactor(): string {
    return this._inputFormFactor;
  }

  setFormFactor(formFactor: string): void {
    this._inputFormFactor = formFactor;
  }

  getManifestHostType(): OSF.ManifestHostType {
    return this._hostType;
  }

  setManifestHostType(hostType: OSF.ManifestHostType): void {
    this._hostType = hostType;
  }

  getCurrentFunctionFileResid(): string {
    return this._currentFunctionFileResid;
  }

  setCurrentFunctionFileResid(currentFunctionFileResid: string): void {
    this._currentFunctionFileResid = currentFunctionFileResid;
  }

  getCurrentVersionOverrideCapabilities(): MOS.Capabilities[] {
    return this._currentVersionOverrideCapabilities;
  }

  getCurrentVersionOverrideNumber(): OSF.VersionOverridesNumber {
    return this._currentVersionOverrideNumber;
  }

  setCurrentVersionOverrideAndCapabilities(
    versionOverrideNumber: OSF.VersionOverridesNumber,
    versionOverrideCapabilities: MOS.Capabilities[],
  ): void {
    this._currentVersionOverrideNumber = versionOverrideNumber;
    this._currentVersionOverrideCapabilities = versionOverrideCapabilities;
  }

  getCurrentRibbonIndex(): number {
    return this._currentRibbonIndex;
  }

  setCurrentRibbonIndex(ribbonIndex: number) {
    this._currentRibbonIndex = ribbonIndex;
  }

  getCurrentMenuIndex(): number {
    return this._currentMenuIndex;
  }

  setCurrentMenuIndex(menuIndex: number) {
    this._currentMenuIndex = menuIndex;
  }

  getCurrentTabIndex(): number {
    return this._currentTabIndex;
  }

  setCurrentTabIndex(tabIndex: number) {
    this._currentTabIndex = tabIndex;
  }

  getCurrentGroupIndex(): number {
    return this._currentGroupIndex;
  }

  setCurrentGroupIndex(groupIndex: number) {
    this._currentGroupIndex = groupIndex;
  }

  getCurrentCustomMobileGroupIndex(): number {
    return this._currentCustomMobileGroupIndex;
  }

  setCurrentCustomMobileGroupIndex(customMobileGroupIndex: number) {
    this._currentCustomMobileGroupIndex = customMobileGroupIndex;
  }

  getCurrentControlIndex(): number {
    return this._currentControlIndex;
  }

  setCurrentControlIndex(controlIndex: number) {
    this._currentControlIndex = controlIndex;
  }

  getCurrentMenuItemIndex(): number {
    return this._currentMenuItemIndex;
  }

  setCurrentMenuItemIndex(menuItemIndex: number) {
    this._currentMenuItemIndex = menuItemIndex;
  }

  setCurrentCommandSurfaceType(commandSurfaceType: CommandSurfaceType) {
    this._currentCommandSurfaceType = commandSurfaceType;
  }

  // Context menu related localization indexes
  getCurrentContextMenuIndex(): number {
    return this._currentContextMenuIndex;
  }

  setCurrentContextMenuIndex(contextMenuIndex: number) {
    this._currentContextMenuIndex = contextMenuIndex;
  }

  getCurrentContextMenuMenuIndex(): number {
    return this._currentContextMenuMenuIndex;
  }

  setCurrentContextMenuMenuIndex(contextMenuMenuIndex: number) {
    this._currentContextMenuMenuIndex = contextMenuMenuIndex;
  }

  getCurrentContextMenuMenuControlIndex(): number {
    return this._currentContextMenuMenuControlIndex;
  }

  setCurrentContextMenuMenuControlIndex(contextMenuMenuControlIndex: number) {
    this._currentContextMenuMenuControlIndex = contextMenuMenuControlIndex;
  }

  getCurrentContextMenuMenuControlMenuItemIndex(): number {
    return this._currentContextMenuMenuControlMenuItemIndex;
  }

  setCurrentContextMenuMenuControlMenuItemIndex(contextMenuMenuControlMenuItemIndex: number) {
    this._currentContextMenuMenuControlMenuItemIndex = contextMenuMenuControlMenuItemIndex;
  }

  getCurrentIconIndex(): number {
    return this._currentIconIndex;
  }

  setCurrentIconIndex(iconIndex: number) {
    this._currentIconIndex = iconIndex;
  }

  getCurrentFixedControlIndex(): number {
    return this._currentFixedControlIndex;
  }

  setCurrentFixedControlIndex(fixedControlIndex: number) {
    this._currentFixedControlIndex = fixedControlIndex;
  }

  setInFixedControl(isInFixedControl: boolean) {
    this._isInFixedControl = isInFixedControl;
  }

  isInFixedControl() {
    return this._isInFixedControl;
  }

  isInRibbon() {
    return this._currentCommandSurfaceType == CommandSurfaceType.Ribbon;
  }
}
